import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

export const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className=" text-gray-200 hover:text-gray-100  py-2 px-4  underline"
    >
      {" "}
      <FontAwesomeIcon
        icon={faArrowLeft}
        size="sm"
        className="text-gray-200 mr-1"
      />
      Back
    </button>
  );
};
